import React from 'react';
var EmptyStateIcon = function (_a) {
    var fill = _a.fill;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "24", height: "24", rx: "12", fill: fill }),
        React.createElement("path", { d: "M9.86866 13.836V12.45H14.1247V13.836H9.86866Z", fill: "#ffffff" })));
};
export default EmptyStateIcon;
//# sourceMappingURL=EmptyStateIcon.js.map